import SEO from '../SEO/SEO';

const About = () => {
  return (
    <>
      <SEO 
        title="Behind TerraNova - Isaac O'Brien, Founder & Principal Geologist"
        description="Meet Isaac O'Brien, Chartered Geologist and founder of TerraNova. Extensive experience in geoenvironmental and geotechnical services across the British Isles with deep Channel Islands knowledge."
        keywords="Isaac O'Brien, Chartered Geologist, geotechnical engineering, geo-environmental services, Channel Islands, Jersey, Guernsey, CGeol, FGS, EurGeol, RoGEP"
        url="/about"
      />
      <div className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-TerraNova-charcoal mb-6">
              Behind TerraNova
            </h1>
            <div className="w-24 h-1 bg-TerraNova-rust mx-auto rounded-full"></div>
          </div>

          {/* Main Content Section */}
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 border-2 border-TerraNova-cream">
            {/* Isaac's Profile Header */}
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-TerraNova-charcoal mb-4">
                <span className="block md:inline">Isaac O'Brien</span>
                <span className="hidden md:inline"> – </span>
                <span className="block md:inline">Founder & Principal Geologist</span>
              </h2>
              <div className="text-lg text-TerraNova-rust font-semibold mb-2">
                BSc (Hons), CGeol, FGS, EurGeol
              </div>
              <div className="text-md text-TerraNova-slate font-medium">
                UK Registered Ground Engineering Professional (RoGEP)
              </div>
            </div>

            {/* Photo and Main Description */}
            <div className="grid lg:grid-cols-2 gap-6 items-center mb-12">
              <div className="order-2 lg:order-1">
                <p className="text-lg text-TerraNova-slate mb-6 leading-relaxed">
                  Isaac is a Chartered Geologist with extensive experience delivering geoenvironmental and geotechnical services across the British Isles.
                </p>
                <p className="text-lg text-TerraNova-slate leading-relaxed">
                  He is passionate about TerraNova providing the highest-quality, trusted service. With deep knowledge of Jersey and Guernsey, he is committed to delivering tailored solutions for local clients—at pricing that reflects the Channel Islands market.
                </p>
              </div>
              
              <div className="order-1 lg:order-2 flex justify-center">
                <div className="relative">
                  <img 
                    src="/images/isaac.png" 
                    alt="Isaac O'Brien - Founder & Principal Geologist"
                    className="w-80 h-80 object-cover rounded-lg shadow-xl border-4 border-TerraNova-cream"
                  />
                </div>
              </div>
            </div>

            {/* Project Experience Section */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-TerraNova-charcoal mb-6">Project Experience</h3>
              <p className="text-lg text-TerraNova-slate mb-6 leading-relaxed">
                Isaac has worked on a wide range of projects, including:
              </p>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  'Housing Developments',
                  'Seaports',
                  'Airports',
                  'Petrochemical Facilities',
                  'Nuclear Sites',
                  'Waste Management Sites',
                  'Energy Infrastructure',
                  'Transport Networks',
                  'Ministry of Defence Sites'
                ].map((project, index) => (
                  <div key={index} className="flex items-center space-x-3 p-3 bg-TerraNova-cream/30 rounded-lg">
                    <div className="w-2 h-2 bg-TerraNova-rust rounded-full flex-shrink-0"></div>
                    <span className="text-TerraNova-slate">{project}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Expertise Section */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-TerraNova-charcoal mb-6">Areas of Expertise</h3>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  'Ground Investigation',
                  'Geotechnical Design', 
                  'Environmental Risk Assessments (including PFAS)',
                  'Remediation Strategies',
                  'Hazardous Waste Classification',
                  'Slope Stability',
                  'Foundation Design',
                  'Regulatory Compliance'
                ].map((expertise, index) => (
                  <div key={index} className="flex items-center space-x-3 p-3 bg-TerraNova-cream/30 rounded-lg">
                    <div className="w-2 h-2 bg-TerraNova-rust rounded-full flex-shrink-0"></div>
                    <span className="text-TerraNova-slate">{expertise}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
